import { Wrench } from 'lucide-react';

export function ServerError() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-950">
      <div className="max-w-md mx-auto text-center px-4">
        <div className="mb-6">
          <div className="flex justify-center mb-4">
            <img 
              src="/icons/maxiron.png" 
              alt="Maxiron" 
              className="h-16 w-auto object-contain dark:hidden"
            />
            <img 
              src="/icons/maxiron_dark.png" 
              alt="Maxiron" 
              className="h-16 w-auto object-contain hidden dark:block"
            />
          </div>
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 dark:bg-blue-900/30 mb-4">
            <Wrench className="w-8 h-8 text-blue-600 dark:text-blue-400" />
          </div>
        </div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-3">
          Portal Update in Progress
        </h1>
        <p className="text-base text-gray-600 dark:text-gray-400 mb-6 leading-relaxed">
          The portal is currently being updated with new features and improvements. We'll be back shortly.
        </p>
        <div className="rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-blue-900 dark:border-blue-900/40 dark:bg-blue-950/30 dark:text-blue-100">
          <p className="text-base font-semibold">
            This page will automatically reload once the update is complete.
          </p>
        </div>
      </div>
    </div>
  );
}

